import { createApi } from '@reduxjs/toolkit/query/react';
import { createBackendBaseQuery, transformApiError } from '../../utils/createAuthBaseQuery';
import { API_URLS } from '../../constants/apiUrl';

export interface ReleaseNote {
  id: number;
  version: string;
  title: string;
  summary: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

const BASE_URL = process.env.REACT_APP_USER_API_BASE_URL as string;

if (!BASE_URL) {
  throw new Error('REACT_APP_USER_API_BASE_URL environment variable is not set');
}

const baseQuery = createBackendBaseQuery(BASE_URL);

export const releaseNotesApiSlice = createApi({
  reducerPath: 'releaseNotesApi',
  baseQuery: baseQuery,
  endpoints(builders) {
    return {
      fetchLatestReleaseNote: builders.query<ReleaseNote | null, void>({
        query() {
          return API_URLS.RELEASE_NOTES.LATEST;
        },
        transformErrorResponse: transformApiError,
      }),

      fetchAllReleaseNotes: builders.query<ReleaseNote[], void>({
        query() {
          return API_URLS.RELEASE_NOTES.ALL;
        },
        transformErrorResponse: transformApiError,
      }),
    };
  },
});

export const { useFetchLatestReleaseNoteQuery, useFetchAllReleaseNotesQuery } =
  releaseNotesApiSlice;
